import {Dispatch} from "redux";
import {JackpotsAction, JackpotsActionTypes} from "../../../types/composer/jackpot/jackpotsTypes";
import axios from "axios";


export const getJackpotsData = (operator: string): any => {
    const apiURL = operator ? `/api/composer/jackpots?operator=${operator}` : `/api/composer/jackpots`;
    return async (dispatch: Dispatch<JackpotsAction>) => {
        try {
            dispatch({type: JackpotsActionTypes.FETCH_JACKPOS_DATA});
            const response = await axios({
                method: 'get',
                url: apiURL,
                withCredentials: false
            });
            dispatch({type: JackpotsActionTypes.FETCH_JACKPOS_DATA_SUCCESS, payload: response.data})
        } catch (error) {
            dispatch({type: JackpotsActionTypes.FETCH_JACKPOS_DATA_ERROR, payload: 'Something wend wrong check Jackpots action controller'});
        }
    }
}